import { Component, Inject, OnInit, HostListener } from "@angular/core";
import { Observable } from "rxjs";

import {
    ITCIAppCustomizationParam,
    ITCIUserInfo,
    TCI_APP_CUSTOMIZATION_TYPE,
    TCIAppMessaging
} from "@tci/common";
import { throttleable } from "./ng-shared/ng-components/ng-charts/utils/throttle";
import { NgUserService } from "./ng-shared/ng-services/ng-user.service";
import { NgWaitService } from "./ng-shared/ng-components/ng-wait/ng-wait.service";
import { Title } from "@angular/platform-browser";
import { NgCustomizationProviderService } from "./ng-shared/ng-services/ng-customization-provider.service";
import { NgEnvVarsService } from "./ng-shared/ng-services/ng-env-vars.service";

// declare const angular: IAngularStatic;
declare const System: any;

@Component({
    selector: "tci-root",
    templateUrl: "./ng-app.component.html",
    styleUrls: ["./ng-app.component.less"]
})
export class NgAppComponent implements OnInit {

    public username = "";
    public user: ITCIUserInfo = null;

    injectScriptsGoogle = false;
    injectScriptsPendo = false;

    uiBlocked = false;
    uiBlockedText = "";

    // Custom Configs
    private CUSTOM_TYPES = TCI_APP_CUSTOMIZATION_TYPE;
    private customConfig: { [key: string]: ITCIAppCustomizationParam } = {};

    constructor(
        @Inject("ngAppMessaging") private appMessaging: TCIAppMessaging,
        private userService: NgUserService,
        private blockUiService: NgWaitService,
        private customizationProviderService: NgCustomizationProviderService,
        private titleService: Title,
        private ngEnvService: NgEnvVarsService
    ) {
        this.blockUiService.getBlockSubject()
            .delay(0) // To avoid "Expression changed" error: https://blog.angular-university.io/angular-debugging/
            .subscribe(state => {
                this.uiBlockedText = state.label;
                this.uiBlocked = state.blocked;
            });

        this.getCustomConfig();
    }

    ngOnInit() {
        this.loadUserName();
    }

    private loadUserName() {
        this.userService
            .getUserInfo()
            .filter(data => !!data)
            .subscribe(data => {
                this.user = data;

                if (data.fn) {
                    this.username = data.fn;
                }
            });
    }

    goToApps() {
        console.log("This is from the goToApps function.");
    }

    // Customizer
    private getCustomConfig() {
        const appCompCustomTypes = [
            this.CUSTOM_TYPES.DOCUMENT_TITLE,
            this.CUSTOM_TYPES.PENDO,
            this.CUSTOM_TYPES.TCI_SCRIPTS_GOOGLE,
            this.CUSTOM_TYPES.TCI_SCRIPTS_PENDO
        ];
        const customConfigObs: Observable<ITCIAppCustomizationParam>[] = appCompCustomTypes.map(customType => {
            // Prepare observables to get the config of each type
            return this
                .customizationProviderService
                .getCustomizations({
                    type: customType
                })
                .map(custom => custom.success ? custom.result : null)
                .map((customParam: ITCIAppCustomizationParam) => {
                    if (customParam) {
                        this.customConfig[customType] = customParam;
                    }
                    return customParam;
                });
        });

        // Request the custom configuration
        Observable.merge(...customConfigObs)
            .take(appCompCustomTypes.length)
            .toArray()
            .subscribe(() => {
                const customTitle = this.getCustomLabel(TCI_APP_CUSTOMIZATION_TYPE.DOCUMENT_TITLE);
                if (customTitle) {
                    this
                        .titleService
                        .setTitle(customTitle);
                }

                const customScriptsGoogle = this.customConfig[TCI_APP_CUSTOMIZATION_TYPE.TCI_SCRIPTS_GOOGLE];
                this.injectScriptsGoogle = customScriptsGoogle && customScriptsGoogle.enabled && customScriptsGoogle.visible;

                const customScriptsPendo = this.customConfig[TCI_APP_CUSTOMIZATION_TYPE.TCI_SCRIPTS_PENDO];
                this.injectScriptsPendo = customScriptsPendo && customScriptsPendo.enabled && customScriptsPendo.visible;
            });
    }

    private getCustomLabel(type: TCI_APP_CUSTOMIZATION_TYPE): string {
        const custom = this.customConfig[type];
        let label = "";

        if (custom) {
            if (custom.enabled && custom.visible) {
                label = custom.label;
            }
        }

        return label;
    }

    // Note: when browser window resize, will recenter the primeng dialog (include new create dialog and all others)
    @HostListener("window:resize")
    @throttleable(100)
    onWindowResize(): void {
        document.querySelectorAll<HTMLElement>("p-dialog .ui-dialog").forEach(item => {
            if (item.style.display === "block") {
                item.style.left = (window.innerWidth - item.clientWidth) / 2 + "px";
                item.style.top = (window.innerHeight - item.clientHeight) / 2 + "px";
            }
        });
    }
}
